module.exports = __webpack_public_path__ + "img/10872_L.eabd8eaf.png";